import React, { FC } from "react";
import { Table, TableBody, TableHead, TableRow } from "@mui/material";
import { t } from "i18next";

import CardTable from "../../CardTable";
import {
  StyledTableBodyCell,
  StyledTableContainer,
  StyledTableHeadCell,
} from "./CardTableContainer.styled";

interface CardTableContainer {
  columns: CardTable["columns"];
  rows: CardTable["rows"];
  type: CardTable["type"];
}

const CardTableContainer: FC<CardTableContainer> = ({ columns, rows, type }) => (
  <StyledTableContainer>
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          {columns.map((column) => (
            <StyledTableHeadCell {...column.tableProps} key={column.field}>
              {typeof column.title === "string" ? t(column.title) : column.title}
            </StyledTableHeadCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((row, i) => (
          <TableRow
            key={`${type}-${i}`}
            sx={{
              "&:last-child td, &:last-child th": { border: 0 },
            }}
          >
            {columns.map((column) => (
              <StyledTableBodyCell
                key={`${type}-${i}-${column.field}`}
                {...column.tableProps}
              >
                {row[column.field]}
              </StyledTableBodyCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </StyledTableContainer>
);

export default CardTableContainer;
